import React from 'react';
import styled from 'styled-components/macro';
import { HelpResourceT } from './utils/types';
import HelpTile from './ResourceTypeTiles/HelpTile';

interface IHelpResourceTiles {
  resources: HelpResourceT[];
}

const debug = false;
const HelpResourceTiles = ({ resources }: IHelpResourceTiles) => {
  if (debug) console.log('HelpResourceTiles | resources:', resources);

  return (
    <TileViewContainer>
      {resources.map((r, index) => (
        <HelpTile key={index} resource={r} />
      ))}
    </TileViewContainer>
  );
};
export default HelpResourceTiles;

const TileViewContainer = styled.div`
  display: flex;
  width: calc(100% - 32px);
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-evenly;
  padding-inline: 16px;
`;
